import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor() { }
}



// WEBPACK FOOTER //
// /Users/magnustrandokken/Desktop/Magson/Web/Foko/foko-angular/src/app/app.component.ts